import cx from 'classnames';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Route, Switch, withRouter } from 'react-router-dom';
import { useComscorePageTracking } from '@zg-rentals/comscore';
import { useSiftScience } from '@zg-rentals/sift-science';

import { analytics, trackComscoreEvent } from '../../../client/analytics';
import sharedConfig from '../../sharedConfig';
import routes from '../../routes';
import { useAuth } from '../../AuthProvider';

import PageTemplate from './PageTemplate';
import ImpersonationNav from './ImpersonationNav';

import './style.scss';

const App = (props) => {
  const { brand } = props;
  const { user } = useAuth();

  useEffect(() => {
    if (brand === sharedConfig.brands.hotpads) {
      analytics.initialize({ brand, userId: user?.userToken || null });
    } else if (brand === sharedConfig.brands.zillow) {
      analytics.initialize({ brand });
    }
  }, [brand, user?.userToken]);

  const impersonatorEmail = user?.impersonatorEmail;
  const impersonatorUserToken = user?.impersonatorUserToken;
  const isImpersonator = impersonatorEmail && impersonatorUserToken;
  const location = useLocation();

  useComscorePageTracking(() => trackComscoreEvent({}), location.pathname);
  useSiftScience({ email: user?.email, isImpersonator: Boolean(impersonatorEmail) });

  return (
    <div
      id="App"
      className={cx('App', {
        hpx: brand === 'hotpads',
        zsg: brand === 'zillow',
        txl: brand === 'trulia',
      })}
    >
      <Helmet titleTemplate={`%s | ${sharedConfig.brandTitles[brand]}`}>
        <title>Renter Hub</title>
      </Helmet>
      {isImpersonator && <ImpersonationNav emailAddress={user?.email} />}
      <PageTemplate>
        <Switch>
          {routes.map((route) => (
            <Route key={route.path} {...route} />
          ))}
        </Switch>
      </PageTemplate>
    </div>
  );
};

const mapStateToProps = (state) => ({
  brand: state.app.brand,
});

const contextTypes = {
  brand: PropTypes.string,
};

App.contextTypes = contextTypes;

App.propTypes = {
  brand: PropTypes.oneOf(['zillow', 'hotpads', 'trulia']),
};

export default withRouter(connect(mapStateToProps)(App));
